module.exports = __webpack_public_path__ + "d384854625d7fcc9803c25c1ee00cda0.png";